/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

import axios from 'axios';
import QS from 'qs';

import store from '../store/store'
import router from '@/router/router'
import {Message} from 'element-ui';
// 环境的切换

//axios.defaults.baseURL = '/api';

const errorMsgCache = new Map();

function showErrorMessage(msg) {
    // 如果传空，给个兜底文案
    const finalMsg = msg || '系统繁忙，请稍后重试';

    // 防抖逻辑：如果3秒内已弹过相同内容，直接忽略
    if (errorMsgCache.has(finalMsg)) {
        return;
    }

    // 真正弹出错误
    Message({
        type: 'error',
        message: finalMsg,
        duration: 3000, // 建议3秒，1秒太快用户看不清
        forbidClick: true
    });

    // 存入缓存
    const timer = setTimeout(() => errorMsgCache.delete(finalMsg), 3000);
    errorMsgCache.set(finalMsg, timer);
}

// 请求超时时间
axios.defaults.timeout = 120000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Service-ID'] = 'shopCouponEnergy';

//请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = store.state.token;

        token && (config.headers.token = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if(response.data.code==='900'){
                Message({
                    type: 'error',
                    message: '登录过期，请重新登录',
                    duration: 1000,
                    forbidClick: true
                });
                // 清除token
                sessionStorage.removeItem('token');
                // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                setTimeout(() => {
                    router.replace({
                        path: '/login'
                    });
                }, 1000);
            }
            else if (response.data.code === '500') {
                // TODO 每周一03:30至09:30为运维时间，不接收任何请求数据！
                // 现在只能做这种消息的提示, 不能统一处理, 可能有其他接口的隐患
                if (response.data.message && response.data.message.includes('运维时间')) {
                    showErrorMessage(response.data.message);
                    return Promise.reject(response);
                } else {
                    // 其他情况正常放行
                    return Promise.resolve(response);
                }
            }
            else{
                return Promise.resolve(response);
            }
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {

        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    router.replace({
                        path: '/login',
                    });
                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    Message({
                        type: 'error',
                        message: '登录过期，请重新登录',
                        duration: 1000,
                        forbidClick: true
                    });
                    // 清除token
                    localStorage.removeItem('token');
                    store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login'
                        });
                    }, 1000);
                    break;
                // 404请求不存在
                case 404:
                    Message({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                case 'ECONNABORTED':
                    Message({
                        message: '连接服务器超时,请稍后重试',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    Message({
                        type: 'error',
                        message: '服务异常请稍后再试',
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params, {arrayFormat: "indices", allowDots: true}))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export function postJsonParams(url,params,data) {
    return axios({
      url: url,
      method: 'POST',
      params: params,
      data
    })
  }
export function postJson(url, params) {
    //axios.defaults.headers.post['Content-Type'] = 'application/json';
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params), {
            headers:
                {
                    'Content-Type': 'application/json'
                }
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export function postFile(url, file,params) {
    let formData = new FormData();
    // fileList.forEach(file => {
    //     formData.append('file', file.raw, file.name);
    // });
    formData.append('file', file.raw, file.name);
    return new Promise((resolve, reject) => {
        axios.post(url, formData,{
            headers: {'Content-Type': 'multipart/form-data;'},
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/*export function postFile(url, params) {
    let formData = new FormData();
    formData.append("file", params);
    return new Promise((resolve, reject) => {
        axios.post(url, formData)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}*/

export function downloadAttachment(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
            responseType: 'blob',
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
